@let schedule = this.schedule();

<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="schedules">
  <div class="top">
    <span class="big">Big screen schedule</span>
    <div class="qr">
      <app-qrcode content="https://oon.gl/UxeNrq"/>
      <span>reserve table</span>
    </div>
  </div>

  @for (event of schedule; track event) {
    <div class="event">
      <div class="opponents">
        <div class="side">{{ event.first }}</div>
        <span>at</span>
        <div class="side">{{ event.second }}</div>
      </div>
      <span class="date">{{ getEventDisplayDate(event.startTime) }}</span>
    </div>
  } @empty {
    <div class="no-events">No scheduled events</div>
  }
</div>
